// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const unmatchedDemandApiPortfolioUnmatchedDemandGetParamsCountryOneMax = 6;

export const unmatchedDemandApiPortfolioUnmatchedDemandGetParamsIndustryOneMax = 200;

export const unmatchedDemandApiPortfolioUnmatchedDemandGetParamsPageDefault = 1;

export const unmatchedDemandApiPortfolioUnmatchedDemandGetParamsPageSizeDefault = 25;
export const unmatchedDemandApiPortfolioUnmatchedDemandGetParamsPageSizeMax = 100;

export const unmatchedDemandApiPortfolioUnmatchedDemandGetParamsStatusDefault = `open`;
export const UnmatchedDemandApiPortfolioUnmatchedDemandGetParams = zod.object({
  "country": zod.union([zod.string().max(unmatchedDemandApiPortfolioUnmatchedDemandGetParamsCountryOneMax),zod.null()]).optional(),
  "industry": zod.union([zod.string().max(unmatchedDemandApiPortfolioUnmatchedDemandGetParamsIndustryOneMax),zod.null()]).optional(),
  "page": zod.int().min(1).default(unmatchedDemandApiPortfolioUnmatchedDemandGetParamsPageDefault),
  "page_size": zod.int().min(1).max(unmatchedDemandApiPortfolioUnmatchedDemandGetParamsPageSizeMax).default(unmatchedDemandApiPortfolioUnmatchedDemandGetParamsPageSizeDefault),
  "status": zod.enum(['open', 'archived', 'all']).default(unmatchedDemandApiPortfolioUnmatchedDemandGetParamsStatusDefault)
})

export type UnmatchedDemandApiPortfolioUnmatchedDemandGetParams = zod.input<typeof UnmatchedDemandApiPortfolioUnmatchedDemandGetParams>;
export type UnmatchedDemandApiPortfolioUnmatchedDemandGetParamsOutput = zod.output<typeof UnmatchedDemandApiPortfolioUnmatchedDemandGetParams>;
